/*
 * DatePicker
 */
import RooDatePicker from './DatePicker';
import RangePicker from './RangePicker';
import TimePicker from './TimeSelect'; // @ts-ignore

RooDatePicker.RangePicker = RangePicker;
RooDatePicker.TimePicker = TimePicker;
export { RangePicker, TimePicker };
export * from './interface';
export default RooDatePicker;